// Profile Module - Root Sagas
// This file aggregates all profile-related sagas

import watchProfileSaga from './Profile/store/saga'
import watchProfileSecuritySaga from './Security/store/saga'

// Root saga for Profile module
export default [
  watchProfileSaga(),
  watchProfileSecuritySaga(),
]

